<script setup>
import { defineProps, defineEmits, computed} from "vue";
import TabelaDeSubitens from "./TabelaDeSubitens/TabelaDeSubitens.vue"

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:removeSubitem",
    "update:descartaSubitem",
    "update:alteraSubitem",
]);

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    emits('update:removeSubitem',update);

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    emits('update:descartaSubitem',update);

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    emits('update:alteraSubitem',update);

};

//==================================================================//
//======================== Mostra SubItens =========================//
//==================================================================//

let mostraSubItens = computed(()=>{

    if(props?.item?.itensQuantidade <= 0){
        return false;
    }

    if(props?.item?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraSubItens"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeSubitens
                    :dado="props?.dado"
                    :item="props?.item"
                    :controlesDesativados="props?.controlesDesativados"
                    @update:removeSubitem="removeSubitem"
                    @update:descartaSubitem="descartaSubitem"
                    @update:alteraSubitem="alteraSubitem"
                ></TabelaDeSubitens>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
